import React, { useState } from 'react';
import { bool, number, string } from 'prop-types';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Icon from 'yoda-core-components/lib/components/Icon';
import ImgNotAvailable from 'yoda-core-components/lib/assets/svg/NoImage.svg';

const Image = ({ alt, iconSize, isSwatchSelected, swatchImageId }) => {
    const [isImageError, setIsImageError] = useState(false);

    return isImageError ? (
        <Icon className={dt(['text-black'])} height={18} width={18}>
            <ImgNotAvailable />
        </Icon>
    ) : (
        <img
            alt={alt}
            className={dt([
                'outline-1',
                'outline',
                'bg-light-white',
                isSwatchSelected ? 'outline-white' : 'outline-gray-15',
            ])}
            height={iconSize}
            onError={() => {
                setIsImageError(true);
            }}
            src={`//jcpenney.scene7.com/is/image/JCPenney/${swatchImageId}?wid=${iconSize}&hei=${iconSize}&op_usm=.4,.8,0,0&resmode=sharp2`}
            width={iconSize}
            aria-pressed={!!isSwatchSelected}
        />
    );
};

Image.defaultProps = {
    alt: '',
    iconSize: 20,
    isSwatchSelected: false,
};

Image.propTypes = {
    swatchImageId: string.isRequired,
    alt: string,
    iconSize: number,
    isSwatchSelected: bool,
};

export default Image;
